import { createModal } from './modal.js';

// Plain read-only popups (Terms and Conditions, Privacy Policy, ...) — no
// form, no confirm action, so createModal() needs no options beyond the
// defaults: showModal(), closable via the close button, backdrop click, or
// Escape (the close button is wired by createModal() itself).
export function initInfoDialogs() {
  document.querySelectorAll('dialog.info-modal').forEach(dialog => createModal(dialog));
}
